var _rect, _mask, _path, _path2, _circle, _circle2, _circle3, _rect2, _rect3, _path3, _rect4, _rect5, _rect6, _rect7, _rect8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStartFromScratch = function SvgStartFromScratch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 137,
    height: 168,
    fill: "none",
    viewBox: "0 0 137 168"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 136,
    height: 167,
    x: 0.5,
    y: 0.5,
    stroke: "#E6E6E6",
    rx: 5.5
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 6a6 6 0 0 1 6-6h125a6 6 0 0 1 6 6v18H0z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.3,
    d: "M0 6a6 6 0 0 1 6-6h125a6 6 0 0 1 6 6v18H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M0 0h137zm137 25H0v-2h137zM0 24V0zM137 0v24z",
    mask: "url(#a)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 12,
    r: 2.5,
    fill: "#E6E6E6"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 12,
    r: 2.5,
    fill: "#E6E6E6"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 12,
    r: 2.5,
    fill: "#E6E6E6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 5,
    x: 89,
    y: 9.5,
    fill: "#E6E6E6",
    rx: 2.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 112,
    height: 51,
    x: 12.5,
    y: 35.5,
    stroke: "#E6E6E6",
    strokeDasharray: "4 4",
    rx: 4.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M57.333 76a3.2 3.2 0 0 1-2.354-.98A3.2 3.2 0 0 1 54 72.668V49.333q0-1.374.98-2.354A3.2 3.2 0 0 1 57.332 46h23.334a3.2 3.2 0 0 1 2.354.98A3.2 3.2 0 0 1 84 49.332v23.334a3.2 3.2 0 0 1-.98 2.354 3.2 3.2 0 0 1-2.353.979zm0-3.333h23.334V49.333H57.333zM59 69.333h20L72.75 61l-5 6.667-3.75-5zm5.938-12.395q.729-.73.729-1.771 0-1.042-.73-1.771a2.4 2.4 0 0 0-1.77-.73 2.4 2.4 0 0 0-1.771.73 2.4 2.4 0 0 0-.73 1.77q0 1.042.73 1.772.729.729 1.77.729 1.042 0 1.772-.73"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 4,
    x: 12,
    y: 101,
    fill: "#E6E6E6",
    rx: 2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 4,
    x: 12,
    y: 111,
    fill: "#E6E6E6",
    rx: 2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 22,
    x: 12,
    y: 123,
    fill: "#E6E6E6",
    rx: 2
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 22,
    x: 72,
    y: 123,
    fill: "#E6E6E6",
    rx: 2
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 93,
    height: 4,
    x: 12,
    y: 153,
    fill: "#E6E6E6",
    rx: 2
  })));
};
export default SvgStartFromScratch;